import * as DashboardConstants from "../../constants/DashboardConstants";
import {Param_Link, Param_LinkToID, Param_LinkToType} from "../../constants/DashboardConstants";
import {getByColName, resultSetSize} from "../charts/DashBoardResultSetUtil";
import {prepareChartData} from "./HighChartsDrawer";
import {calcChartTitle} from "./HighGaugeDrawer";
import {isNotEmptyOrNull} from "../../common/NamaCommon";
import {NamaRouterInstance} from "../../routing/NamaRouter";
import {editPlace} from "../../routing/places";

export function addLinkOptionsToPoint(params, list, i, point) {
    addOptionToPoint(params, Param_Link, list, point, i);
    addOptionToPoint(params, Param_LinkToID, list, point, i);
    addOptionToPoint(params, Param_LinkToType, list, point, i);
}

export function handleChartClick() {
    if (!this.options)
        return;
    let link = this.options[Param_Link];
    let linkToId = this.options[Param_LinkToID];
    let linkToType = this.options[Param_LinkToType];
    if (isNotEmptyOrNull(link)) {
        if (link.contains("//"))
            Window.open(link, "_blank", "");
        else
            goToInternalURL(link);
    } else if (isNotEmptyOrNull(linkToType) && isNotEmptyOrNull(linkToId)) {
        NamaRouterInstance.goTo(editPlace(linkToType, linkToId));
    }
}

function goToInternalURL(internalURL) {
    if (internalURL.startsWith("#"))
        window.location.hash = internalURL;
    else
        window.location.href = window.location.href.replace(window.location.hash, "").replace("#", "") + internalURL;
}

function addOptionToPoint(params, paramName, list, point, i) {
    let value = getByColName(i, params[paramName], list);
    if (!value)
        return;
    point[paramName] = value;
}

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 *
 * @param w
 * @return {JQuery | jQuery | HTMLElement}
 */
export function createHighPieChart(userDashboardChartLine, h, w, is3D, widget, Highcharts) {
    let params = userDashboardChartLine.parameters;
    let list = userDashboardChartLine.resultSet;
    let points = [];
    let labelParam = params[DashboardConstants.Param_Label];
    let valueParam = params[DashboardConstants.Param_Value];
    for (let i = 0; i < resultSetSize(list); i++) {
        let label = getByColName(i, labelParam, list);
        let pointValue = Math.abs(parseFloat(getByColName(i, valueParam, list)));
        points[i] = {name: label, y: pointValue};
        addLinkOptionsToPoint(params, list, i, points[i]);
    }
    let options3D = {enabled: false};
    let depth = 0;
    if (is3D) {
        options3D = {
            enabled: true,
            alpha: 45,
            beta: 0
        };
        depth = 75;
    }
    let chartData = {
            type: 'pie',
            options3d: options3D,
        };
    chartData = prepareChartData(chartData, w, h);
    let widgetId = widget.attr('id');
    Highcharts.chart(widgetId, {
        chart: chartData,
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                depth: depth,
                dataLabels: {
                    enabled: true,
                    format: '<b>{point.name}</b>: {point.y:,.0f} ',
                    style: {
                        color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black',
                        textOutline: 'none'
                    },
                    allowOverlap: true,
                    padding: 0,
                    useHTML: true
                },
                point: {
                    events: {
                        click: handleChartClick
                    }
                }
            }
        },
        title: {
            text: calcChartTitle(userDashboardChartLine)
        },
        tooltip: {
            pointFormat: '{point.percentage:.1f}%</b>',
            useHTML: true
        },
        series: [{
            colorByPoint: true,
            data: points
        }]
    });
}